import React from "react";

const Breadcrumbs = () => {
  return (
    <section id="breadcrumbs" className="breadcrumbs">
      <div className="container">
        <ol>
          <li>
            <a href="index.html">Home</a>
          </li>
          <li>За нас</li>
        </ol>
        <h2>За нас</h2>
      </div>
    </section>
  );
};

export default Breadcrumbs;
